export default {"src":"/_next/static/media/w_fb.2a97bcce.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};